import { render, staticRenderFns } from "./CRUDClientes.vue?vue&type=template&id=af528f42&scoped=true&"
import script from "./CRUDClientes.vue?vue&type=script&lang=js&"
export * from "./CRUDClientes.vue?vue&type=script&lang=js&"
import style0 from "./CRUDClientes.vue?vue&type=style&index=0&id=af528f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af528f42",
  null
  
)

export default component.exports